import { render, staticRenderFns } from "./keywordOptimize.vue?vue&type=template&id=fcf3521a&scoped=true"
import script from "./keywordOptimize.vue?vue&type=script&lang=js"
export * from "./keywordOptimize.vue?vue&type=script&lang=js"
import style0 from "./keywordOptimize.vue?vue&type=style&index=0&id=fcf3521a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf3521a",
  null
  
)

export default component.exports